import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()({
  legend: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },

  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem',

    '> div': {
      width: 20,
      height: 20,
    }
  },

  legendLabel: {
    fontSize: 14,
  },
});
